// extracted by mini-css-extract-plugin
module.exports = {"header":"header_university_header__8yNCD","logo":"header_university_logo__AObrG"};